import { render, staticRenderFns } from "./entity-info.vue?vue&type=template&id=6c1cf3c3&scoped=true&"
import script from "./entity-info.vue?vue&type=script&lang=js&"
export * from "./entity-info.vue?vue&type=script&lang=js&"
import style0 from "./entity-info.vue?vue&type=style&index=0&id=6c1cf3c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cf3c3",
  null
  
)

export default component.exports